<template>
  <div v-if="isFacebookChannel || isGoogleAdChannel" class="bg-white rounded">
    <div class="px-4 pt-3 flex flex-col space-y-2">
      <div>
        <template v-if="facebookCampaign">
          <h5 class="text-xs uppercase tracking-wider text-gray-600">Facebook Campaign</h5>
          <h1 class="text-base font-normal leading-6">
            {{ facebookCampaign.name }}
          </h1>
          <span class="text-xs text-gray-600">{{ facebookCampaign.id }}</span>
        </template>
        <template v-else-if="isFacebookChannel">
          <h1 class="text-base font-normal leading-6">Facebook Campaign</h1>
        </template>
        <template v-if="googleAdsCampaign">
          <h5 class="text-xs uppercase tracking-wider text-gray-600">Google Ad Campaign</h5>
          <h1 class="text-base font-normal leading-6">
            {{ googleAdsCampaign.name }}
          </h1>
          <span class="text-xs text-gray-600">{{ googleAdsCampaign.id }}</span>
        </template>
        <template v-else-if="isGoogleAdChannel">
          <h1 class="text-base font-normal leading-6">Google Ad Campaign</h1>
        </template>
      </div>
      <div>
        <span class="text-gray-600 text-sm"> Gross Profit Factor (Mark Up) </span>
        <h2 class="text-base font-normal leading-6">{{ grossProfitFactor }} ({{ markUp }})</h2>
      </div>
    </div>
    <div class="p-4 space-x-2">
      <ChannelEditModalForm :channel="channel" @updated="handleChannelUpdated" />
      <DeleteChannel :channel="channel" :campaign="campaign" @deleted="handleChannelDeleted" />
    </div>
  </div>

  <div v-else class="flex">
    <div class="flex-1 px-4">Unknown channel</div>
  </div>
</template>

<script>
import Numbro from '@/utils/numbro';
import ChannelEditModalForm from '@/forms/ChannelEditModalForm.vue';
import DeleteChannel from './DeleteChannel.vue';

export default {
  components: {
    ChannelEditModalForm,
    DeleteChannel,
  },
  props: {
    channel: {
      type: Object,
      required: true,
    },
    campaign: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isFacebookChannel() {
      return this.channel?.channableType === 'facebook_campaign';
    },
    isGoogleAdChannel() {
      return this.channel?.channableType === 'ga_campaign';
    },
    isLinked() {
      return this.channel.channableId;
    },
    facebookCampaign() {
      return this.channel?.facebookCampaign || null;
    },
    googleAdsCampaign() {
      return this.channel?.gaCampaign || null;
    },
    grossProfitFactor() {
      return Numbro(this.channel.grossProfitFactor).format({
        mantissa: 2,
      });
    },
    markUp() {
      return Numbro((this.channel.grossProfitFactor - 1) / this.channel.grossProfitFactor).format({
        output: 'percent',
        mantissa: 2,
      });
    },
  },
  methods: {
    handleChannelUpdated() {
      this.$emit('changed');
    },
    handleChannelDeleted() {
      this.$emit('deleted');
    },
  },
};
</script>
